// extracted by mini-css-extract-plugin
module.exports = {"pollSite":"Complaints_pollSite__3H4Bf","date":"Complaints_date__2An12","message":"Complaints_message__2Eem8"};